import loadable from "@loadable/component";

import LoadingIndicator from "../../components/LoadingIndicator";

const LoadableComponent = loadable(() => import("./index"), {
  fallback: <LoadingIndicator fullPage />,
});

export default LoadableComponent;
